import React from "react";
import FooterOne from "../common/footer/FooterOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import BreadCrumbOne from "../elements/breadcrumb/BreadCrumbOne";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SEO from "../common/SEO";
import HeaderFour from "../common/header/HeaderFour";
import ChatbotTwo from "./ChatbotTwo";

const TermsOfUse = () => {
  return (
    <>
      <SEO />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderFour />
        <BreadCrumbOne title="Terms Of Use" page="Terms Of Use" />
        <div className="section-padding privacy-policy-area">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="privacy-policy-content">
                  <h2>Terms and Conditions CLIF AI</h2>
                  <p className="last-updated">Last Updated: March 31, 2025</p>

                  <div className="section">
                    <h2>Acceptance of Terms</h2>
                    <p>
                      By accessing and using CLIF AI ("the Service"), you
                      acknowledge that you have read, understood, and agree to
                      be bound by these Terms and Conditions ("Terms"). If you
                      do not agree to these Terms, please refrain from using the
                      Service.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Definitions</h2>
                    <ul>
                      <li>
                        "Service" refers to CLIF AI and all its associated
                        services and features.
                      </li>
                      <li>
                        "User," "you," and "your" refer to any individual or
                        entity using the Service.
                      </li>
                      <li>
                        "We," "us," and "our" refer to CLIF AI and its
                        operators.
                      </li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>User Account Registration</h2>
                    <p>
                      To access certain features of the Service, you may be
                      required to register for an account.
                    </p>
                    <p> You agree to:</p>
                    <ul>
                      <li>
                        Provide accurate and complete registration information.
                      </li>
                      <li>
                        Maintain the security of your account credentials.
                      </li>
                      <li>
                        Promptly update any changes to your registration
                        registration information.
                      </li>
                      <li>
                        Accept responsibility for all activities that occur
                        under your account.
                      </li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>User Conduct</h2>
                    <p>You agree not to:</p>
                    <ul>
                      <li>Use the Service for any illegal purpose.</li>
                      <li>
                        Attempt to gain unauthorized access to any portion of
                        the Service.
                      </li>
                      <li>Interfere with or disrupt the Service or servers.</li>
                      <li>Upload or transmit malicious code or viruses.</li>
                      <li>Collect user information without consent.</li>
                      <li>Impersonate any person or entity.</li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>Intellectual Property Rights</h2>
                    <p>
                      All content on the Service, including but not limited to
                      text, graphics, logos, and software, is the property of
                      CLIF AI or its licensors and is protected by intellectual
                      property laws.
                    </p>
                    <p>
                      Users may not copy, modify, distribute, or create
                      derivative works without explicit permission.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Privacy Policy and Data Usage</h2>
                    <p>
                      Your use of the Service is also governed by our Privacy
                      Policy, which is incorporated into these Terms by
                      reference.
                    </p>
                    <p>
                      By using the Service, you consent to the collection, use,
                      and sharing of your data as outlined in the Privacy
                      Policy. This includes, but is not limited to, the use of
                      your data for research, model training, and educational
                      purposes.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Third-Party Links</h2>
                    <p>
                      The Service may contain links to third-party websites. We
                      are not responsible for the content or practices of these
                      websites.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Disclaimers and Limitation of Liability</h2>
                    <p>
                      <strong>No Warranties:</strong> The Service is provided
                      "as is" and "as available" without warranties of any kind,
                      either express or implied. We do not warrant that the
                      Service will be uninterrupted, error-free, or free of
                      harmful components.
                    </p>
                    <p>
                      <strong>Limitation of Liability:</strong> To the fullest
                      extent permitted by law, CLIF AI and its affiliates,
                      officers, employees, agents, partners, and licensors shall
                      not be liable for any indirect, incidental, special,
                      consequential, or punitive damages, or any loss of profits
                      or revenues, whether incurred directly or indirectly, or
                      any loss of data, use, goodwill, or other intangible
                      losses, resulting from:
                    </p>
                    <ul>
                      <li>Your use or inability to use the Service.</li>
                      <li>
                        Any unauthorized access to or use of our servers and/or
                        any personal information stored therein.
                      </li>
                      <li>
                        Any interruption or cessation of transmission to or from
                        the Service.
                      </li>
                      <li>
                        Any bugs, viruses, trojan horses, or the like that may
                        be transmitted to or through our Service by any third
                        party.
                      </li>
                      <li>
                        Any errors or omissions in any content or for any loss
                        or damage incurred as a result of the use of any content
                        posted, emailed, transmitted, or otherwise made
                        available through the Service.
                      </li>
                    </ul>
                    <p>
                      <strong>Indemnification:</strong> You agree to indemnify
                      and hold harmless CLIF AI and its affiliates, officers,
                      agents, employees, partners, and licensors from any claim
                      or demand, including reasonable attorneys' fees, made by
                      any third party due to or arising out of your use of the
                      Service, your violation of these Terms, or your violation
                      of any rights of another.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Service Modifications</h2>
                    <p>We reserve the right to:</p>
                    <ul>
                      <li>Modify or discontinue any part of the Service.</li>
                      <li>Update these Terms at any time.</li>
                      <li>Change our fees or payment policies with notice.</li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>Termination</h2>
                    <p>
                      We may terminate or suspend your access to the Service at
                      our discretion, without notice, for conduct that we
                      believe violates these Terms.
                    </p>
                    <p>
                      Upon termination, your right to use the Service will
                      immediately cease.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Governing Law</h2>
                    <p>
                      These Terms shall be governed by and construed in
                      accordance with the laws of the State of Delaware, without
                      regard to its conflict of law principles.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Contact Information</h2>
                    <p>
                      For questions about these Terms, please contact us at{" "}
                      <a href="mailto:contact@clif.ai">contact@clif.ai</a>.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Severability</h2>
                    <p>
                      If any provision of these Terms is found to be
                      unenforceable, the remaining provisions will remain in
                      full force and effect.
                    </p>
                  </div>

                  <div className="section">
                    <h2>Changes to Terms</h2>
                    <p>We reserve the right to modify</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CtaLayoutOne />
        <FooterOne parentClass="" />
        <ChatbotTwo />
      </main>
    </>
  );
};

export default TermsOfUse;
